// extracted by mini-css-extract-plugin
export var connectionButton = "_bf-1";
export var rightPanel = "_bf-3";
export var stepDescription = "_bf-2";
export var stepIcon = "_bf-0";